var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83888 8.0711L0.156216 4.38843C-0.0520719 4.18014 -0.0520719 3.84233 0.156216 3.63404L0.392071 3.39819C0.600359 3.1899 0.93817 3.1899 1.14646 3.39819L4.21258 6.46431L8.85354 1.8229C9.06183 1.61462 9.39964 1.61462 9.60793 1.8229L9.84378 2.05876C10.0521 2.26705 10.0521 2.60486 9.84378 2.81314L4.58583 8.0711C4.37973 8.2772 4.04498 8.2772 3.83888 8.0711Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.8d489ce4852c98d98a6a8f982763d387.svg";
export { ForwardRef as ReactComponent };